import api from './api';

/**
 * Busca todas as notificações do usuário logado.
 * Pode receber parâmetros de paginação e filtragem.
 */
export const getNotifications = async (params = {}) => {
  const response = await api.get('/v1/notifications', { params });
  return response.data;
};

/**
 * Marca uma notificação específica como lida.
 */
export const markNotificationAsRead = async (notificationId) => {
  const response = await api.put(`/v1/notifications/${notificationId}/read`);
  return response.data;
};

/**
 * Marca todas as notificações do usuário como lidas.
 */
export const markAllNotificationsAsRead = async () => {
  const response = await api.put('/v1/notifications/read-all');
  return response.data;
};

/**
 * Deleta/Oculta uma notificação.
 */
export const deleteNotification = async (notificationId) => {
  const response = await api.delete(`/v1/notifications/${notificationId}`);
  return response.data;
};
